var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.852 43.198C429.36 34.688 418.066 30 406.05 30h-19.945v20c0 22.056-17.924 40-39.956 40h-179.8c-22.032 0-39.956-17.944-39.956-40V30h-20.011c-24.758 0-44.922 20.164-44.95 44.95l-.432 392c-.014 12.029 4.656 23.341 13.147 31.852C82.64 507.313 93.934 512 105.95 512h299.667c24.758 0 44.923-20.164 44.95-44.95l.433-392c.014-12.029-4.656-23.341-13.148-31.852zM261.094 180h106.453c8.275 0 14.983 6.716 14.983 15s-6.708 15-14.983 15H261.094c-8.275 0-14.983-6.716-14.983-15s6.708-15 14.983-15zm0 100h106.453c8.275 0 14.983 6.716 14.983 15s-6.708 15-14.983 15H261.094c-8.275 0-14.983-6.716-14.983-15s6.708-15 14.983-15zm0 100h106.881c8.275 0 14.983 6.716 14.983 15s-6.708 15-14.983 15H261.094c-8.275 0-14.983-6.716-14.983-15s6.708-15 14.983-15zM133.431 180.592c5.852-5.858 15.338-5.858 21.19 0l8.147 8.157 34.554-34.592c5.852-5.857 15.338-5.859 21.189 0 5.851 5.857 5.851 15.355 0 21.213l-45.149 45.198a14.972 14.972 0 0 1-21.19 0l-18.742-18.764c-5.851-5.857-5.851-15.355.001-21.212zm0 107.637c5.852-5.858 15.338-5.858 21.19 0l8.147 8.156 34.554-34.592c5.851-5.857 15.338-5.857 21.189 0s5.851 15.355 0 21.213l-45.149 45.199a14.974 14.974 0 0 1-21.19 0l-18.742-18.764c-5.851-5.857-5.851-15.354.001-21.212zm0 100c5.852-5.858 15.338-5.858 21.19 0l8.147 8.156 34.554-34.592c5.851-5.857 15.338-5.857 21.189 0s5.851 15.355 0 21.213l-45.149 45.199a14.974 14.974 0 0 1-21.19 0l-18.742-18.764c-5.851-5.857-5.851-15.354.001-21.212z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.361 50c0 5.523 4.472 10 9.989 10h179.8c5.517 0 9.989-4.477 9.989-10V10c0-5.523-4.472-10-9.989-10h-179.8c-5.517 0-9.989 4.477-9.989 10z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverables);
export default __webpack_public_path__ + "static/media/deliverables.e87db34015584d02d276bb02ae2eaec9.svg";
export { ForwardRef as ReactComponent };